import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReverbnationComponent } from './simple-icons-reverbnation.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReverbnationComponent ],
    exports:      [ SimpleIconsReverbnationComponent ],
    bootstrap:    []
})
export class SimpleIconsReverbnationModule {}
